module.exports = __webpack_public_path__ + "img/transfererror.4bad5580.svg";